
import { Options, Vue } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    fill: {
      type: String,
      default: 'none',
    },
  },
})
export default class IconStar extends Vue {}
